/* @flow */
import { toCamelCase } from '../helpers/string'
import CurrentStep from './current_step'
import type { StepListType, StepListEntryType } from './current_step'

export const findClass = (classes: StepListType, name: string): ?StepListEntryType => {
  return classes.find((obj) => obj && obj.name == name)
}

export const pickClasses = (classes: StepListType, arr: Array<string>, suffix: ?string = null): StepListType => {
  const result: StepListType = []
  arr.forEach((name) => {
    let found: ?StepListEntryType
    if (suffix) found = findClass(classes, toCamelCase(`${name}_${suffix}`))
    found = found || findClass(classes, name)
    if (found) result.push(found)
  })
  return result
}

const cache = []

/**
 * fetches the current step and if not found fetches the first one
 * @param  {Array} steps
 * @param  {string} step
 * @return {CurrentStep}
 */
const chooseStep = (steps: StepListType, step: string): CurrentStep => {
  let current =
    steps.find((entry: StepListEntryType): boolean => {
      return entry.name === step
    }) || steps[0]

  const fromCache = cache.find((entry) => {
    return entry.steps == steps && entry.step == current
  })
  if (fromCache) return fromCache.current

  const currentStep = new CurrentStep(steps, current)
  cache.push({ steps, step: current, current: currentStep })
  return currentStep
}

export default chooseStep
